import React, { Component } from 'react'
import { get } from 'lodash'
import { compose } from 'recompose'

import { withRouter } from 'react-router-dom'

/**
 * Adapter which partially emulates react-router 3 while using react-router 4
 */
function hoc() {
  return ComposedComponent => {
    const enhance = compose(
      withRouter
    )

    class RouterAdapter extends Component {
      render() {
        return (
          <ComposedComponent
            {...this.props}
            params={get(this.props, 'match.params')}
          />
        )
      }
    }
    return enhance(RouterAdapter)
  }
}

export default hoc
